/**
 * useCameraFlip (web) — retourner sa caméra en pleine séance, quand le navigateur en connaît une autre.
 *
 * L'ancien n'avait pas de bouton au web (`useSwitchCamera.web.js` ne faisait rien) : on y changeait de
 * caméra par la liste du « ^ », que le nouvel espace garde (`useRoomDevices`). Le retournement passe par
 * ce même choix : la salle change d'appareil (`switchActiveDevice` de LiveKit), la piste publiée est
 * remplacée sans quitter la salle, et le choix entre dans celui du test d'avant séance.
 */
import { useMemo } from "react"

import { type EngineTelemetry } from "../../shared/telemetry"
import { cameraSideOfLabel, nextCameraId, type CameraFlip } from "./cameraFlip"
import { type RoomDeviceChoice } from "./roomDevices"

export function useCameraFlip(camera: RoomDeviceChoice | null, telemetry: EngineTelemetry): CameraFlip | null {
    void telemetry
    return useMemo(() => {
        if (camera == null) return null
        const cameras = camera.devices.map((device) => ({ id: device.id, side: cameraSideOfLabel(device.label) }))
        const next = nextCameraId(cameras, camera.activeId)
        return next != null ? { flip: () => camera.select(next) } : null
    }, [camera])
}
